export default {
    data() {
        return {
            optionSliderView: {
                spaceBetween: 24,
                loop: true,
                cursor: "grab",
                speed: 500,
                navigation: {
                    nextEl: '.js-slider-next',
                    prevEl: '.js-slider-prev',
                }
            }
        }
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/slider-view/component.js